import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Typography, Menu, MenuItem} from 'views/components';
import {translate} from 'views/module';

import backend from 'utils/backend';

const StatusDropdown = (props) => {
  const {
    jobRn,
    status: initialStatus,
    statusProgressWrap: progressWrap,
  } = props;

  const [status, setStatus] = React.useState(initialStatus);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [stage, setStage] = React.useState('FILL');

  React.useEffect(() => {
    setStatus(initialStatus);
  }, [initialStatus]);

  const isMenuOpen = Boolean(anchorEl);
  const isSaving = stage === 'LOADING';
  const isActive = status === 'ACTIVE';
  const statusOptions = ['ACTIVE', 'INACTIVE'];

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleToggle = (event) => {
    event.stopPropagation();

    if (isSaving) {
      return;
    }

    if (isMenuOpen) {
      closeMenu();
      return;
    }

    setAnchorEl(event.currentTarget);
  };

  const handleOptionSelect = (statusKey) => {
    closeMenu();

    if (statusKey === status) {
      return;
    }

    progressWrap(async () => {
      const result = await backend.career.updateJobStatus(jobRn, {status: statusKey});
      setStatus(result.job.status);
    }, {setStage});
  };

  // The card navigates on click. The menu renders in a portal, but React
  // still bubbles its events up to the card, so stop them here.
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <>
      <Box
        onClick={handleToggle}
        onAuxClick={stopPropagation}
        style={{
          backgroundColor: isActive ? '#e8f5e9' : '#9e9e9e',
          borderColor: isActive ? '#43a047' : '#757575',
          borderWidth: 1,
          borderRadius: 16,
          alignItems: 'center',
          display: 'inline-flex',
          padding: '4px 10px',
          marginRight: 10,
        }}
      >
        <Typography sx={{fontSize: 12, color: isActive ? '#388e3c' : '#fff', fontWeight: 500}}>
          {status}
        </Typography>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={closeMenu}
        onClick={stopPropagation}
        onAuxClick={stopPropagation}
      >
        {
          statusOptions.map((statusKey) => (
            <MenuItem
              key={statusKey}
              selected={statusKey === status}
              onClick={() => handleOptionSelect(statusKey)}
            >
              {translate(`career.Status.${statusKey}.Title`)}
            </MenuItem>
          ))
        }
      </Menu>
    </>
  );
};

StatusDropdown.propTypes = {
  jobRn: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(StatusDropdown));
